import { adaptiveFontSize, getMobileMaxColumnWidth } from './helpers'

const textKnownHeight = (parent, config) => {
    const { utilities, section1, footer, banner, badge, name } = parent
    const { displayBanner } = config
    const height =
        (displayBanner ? banner.height : 0) +
        badge.new.height +
        utilities.height +
        section1.height +
        footer.height +
        name.height
    return height
}

export const DESKTOP_TEXT_STYLES = {
    sm: {
        text: {
            seeAll: {
                fontSize: 15,
            },
            title: {
                fontSize: 15,
            },
            column: {
                maxWidth: 152,
            },
            utilities: {
                iconSize: 0.5,
                height: 30,
            },
            viewers: {
                iconSize: 0.45,
                fontSize: 9,
                offsetY: 1,
            },
            name: {
                fontSize: adaptiveFontSize({ lowerBound: 9 }),
                fontSizeMinimum: 7.7,
                height: 24,
            },
            section1: {
                height: 18,
            },
            badge: {
                status: {
                    iconSize: 0.5,
                    fontSize: 8,
                    offsetX: 4,
                    offsetY: 4,
                },
                missMFC: {},
                priorMissMFC: {
                    height: 12,
                    width: 12,
                },
                new: {
                    height: 12,
                },
            },
            banner: {
                popular: {
                    viewers: {
                        margin: '0 4px',
                    },
                },
                trending: {
                    diff: {
                        margin: '0 2px 0 1px',
                    },
                    text: 'views/min',
                },
                new: {
                    time: {
                        margin: '0 4px',
                    },
                },
                missMFC: {
                    rank: {
                        margin: '0 3px',
                    },
                    text: 'MFC',
                },
                minimumWidth: 120,
                iconSize: 0.6,
                fontSize: 9,
                height: 16,
            },
            footer: {
                margin: '0 4px 0 0px',
                height: 28,
            },
            _knownHeight: textKnownHeight,
        },
    },
    md: {
        text: {
            seeAll: {
                fontSize: 16,
            },
            title: {
                fontSize: 17,
            },
            column: {
                maxWidth: 200,
            },
            utilities: {
                iconSize: 0.8,
                height: 34,
            },
            viewers: {
                fontSize: 10.5,
                iconSize: 0.5,
                offsetY: 0,
            },
            new: {
                offsetY: 26,
            },
            name: {
                fontSize: adaptiveFontSize({ lowerBound: 10 }),
                fontSizeMinimum: 11,
                height: 24,
            },
            section1: {
                height: 18,
            },
            badge: {
                status: {
                    iconSize: 0.6,
                    fontSize: 10,
                    offsetX: 5,
                    offsetY: 5,
                },
                missMFC: {},
                priorMissMFC: {
                    height: 14,
                    width: 14,
                },
                new: {
                    height: 15,
                },
            },
            banner: {
                popular: {
                    viewers: {
                        margin: '0 4px',
                    },
                },
                trending: {
                    diff: {
                        margin: '0 2px 0 1px',
                    },
                    text: 'views/minute',
                },
                new: {
                    time: {
                        margin: '0 4px',
                    },
                },
                missMFC: {
                    rank: {
                        margin: '0 3px',
                    },
                },
                iconSize: 0.6,
                fontSize: 9.4,
                height: 22,
            },
            footer: {
                margin: '0 8px 0 0px',
                height: 36,
            },
            _knownHeight: textKnownHeight,
        },
    },
    lg: {
        text: {
            seeAll: {
                fontSize: 17,
            },
            title: {
                fontSize: 19,
            },
            column: {
                maxWidth: 300,
            },
            utilities: {
                iconSize: 0.9,
                height: 40,
            },
            viewers: {
                iconSize: 0.6,
                fontSize: 12,
                offsetY: 0,
            },
            new: {
                offsetY: 28,
            },
            section1: {
                height: 22,
            },
            name: {
                fontSize: adaptiveFontSize({ lowerBound: 15, upperBound: 20 }),
                fontSizeMinimum: 17,
                height: 30,
            },
            badge: {
                status: {
                    iconSize: 0.8,
                    fontSize: 12,
                    offsetX: 6,
                    offsetY: 6,
                },
                missMFC: {},
                priorMissMFC: {
                    height: 19,
                    width: 19,
                },
                new: {
                    height: 18,
                },
            },
            banner: {
                popular: {
                    viewers: {
                        margin: '0 4px',
                    },
                },
                trending: {
                    diff: {
                        margin: '0 4px 0 1px',
                    },
                    text: 'viewers per minute',
                },
                new: {
                    time: {
                        margin: '0 4px',
                    },
                },
                missMFC: {
                    rank: {
                        margin: '0 3px',
                    },
                },
                iconSize: 0.8,
                fontSize: 14,
                height: 26,
            },
            footer: {
                margin: '0 12px 0 0px',
                height: 44,
            },
            _knownHeight: textKnownHeight,
        },
    },
}

export const MOBILE_TEXT_STYLES = {
    sm: {
        text: {
            seeAll: {
                fontSize: 9.5,
            },
            title: {
                fontSize: 15,
            },
            column: {
                maxWidth: getMobileMaxColumnWidth(4),
            },
            utilities: {
                iconSize: 0.35,
                height: 24,
            },
            viewers: {
                iconSize: 0.45,
                fontSize: 9.5,
                offsetY: 1,
            },
            new: {
                offsetY: 18,
            },
            name: {
                fontSize: adaptiveFontSize({ lowerBound: 8.5, fixed: true }),
                fontSizeMinimum: 7.7,
                height: 18,
            },
            section1: {
                height: 16,
            },
            badge: {
                status: {
                    iconSize: 0.35,
                    fontSize: 7,
                    offsetX: 2,
                    offsetY: 2,
                },
                missMFC: {
                    compact: true,
                },
                priorMissMFC: {
                    height: 8.5,
                    width: 8.5,
                },
                new: {
                    height: 10,
                },
            },
            banner: {
                popular: {
                    viewers: {
                        margin: '0 2px',
                    },
                    text: 'viewers',
                },
                trending: {
                    diff: {
                        margin: '0 2px 0 0',
                    },
                    text: 'views per min',
                },
                new: {
                    time: {
                        margin: '0 2px',
                    },
                },
                missMFC: {
                    rank: {
                        margin: '0 2px',
                    },
                    text: 'MFC',
                },
                iconSize: 0.4,
                fontSize: 7,
                height: 16,
            },
            footer: {
                margin: '0 2px 0 -2px',
                height: 22,
            },
            _knownHeight: textKnownHeight,
        },
    },
    md: {
        text: {
            seeAll: {
                fontSize: 12.5,
            },
            title: {
                fontSize: 16,
            },
            column: {
                maxWidth: getMobileMaxColumnWidth(3),
            },
            utilities: {
                iconSize: 0.5,
                height: 28,
            },
            viewers: {
                fontSize: 10,
                iconSize: 0.47,
                offsetY: 1,
            },
            new: {
                offsetY: 22,
            },
            name: {
                fontSize: adaptiveFontSize({ lowerBound: 9, fixed: true }),
                fontSizeMinimum: 7.7,
                height: 24,
            },
            section1: {
                height: 18,
            },
            badge: {
                status: {
                    iconSize: 0.5,
                    fontSize: 8,
                    offsetX: 2,
                    offsetY: 2,
                },
                missMFC: {
                    fontSize: 8,
                },
                priorMissMFC: {
                    height: 12,
                    width: 12,
                },
                new: {
                    height: 12,
                },
            },
            banner: {
                popular: {
                    viewers: {
                        margin: '0 2px',
                    },
                },
                trending: {
                    diff: {
                        margin: '0 2px 0 1px',
                    },
                    text: 'views per min',
                },
                new: {
                    time: {
                        margin: '0 2px',
                    },
                },
                missMFC: {
                    rank: {
                        margin: '0 2px',
                    },
                    text: 'MFC',
                },
                iconSize: 0.4,
                fontSize: 8,
                height: 22,
            },
            footer: {
                margin: '0px 3px 0px 0px',
                height: 26,
            },
            _knownHeight: textKnownHeight,
        },
    },
    lg: {
        text: {
            seeAll: {
                fontSize: 14,
            },
            title: {
                fontSize: 17,
            },
            column: {
                maxWidth: getMobileMaxColumnWidth(2),
            },
            utilities: {
                iconSize: 0.6,
                height: 31,
            },
            viewers: {
                fontSize: 10.5,
                iconSize: 0.5,
                offsetY: 0,
            },
            new: {
                offsetY: 25,
            },
            name: {
                fontSize: adaptiveFontSize({ lowerBound: 9.5, fixed: true }),
                fontSizeMinimum: 7.7,
                height: 30,
            },
            section1: {
                height: 18,
            },
            badge: {
                status: {
                    iconSize: 0.5,
                    fontSize: 9,
                    offsetX: 3,
                    offsetY: 3,
                },
                missMFC: {
                    fontSize: 9,
                },
                priorMissMFC: {
                    height: 12,
                    width: 12,
                },
                new: {
                    height: 13,
                },
            },
            banner: {
                popular: {
                    viewers: {
                        margin: '0 4px',
                    },
                },
                trending: {
                    diff: {
                        margin: '0 4px 0 2px',
                    },
                    text: 'viewers per minute',
                },
                new: {
                    time: {
                        margin: '0 4px',
                    },
                },
                missMFC: {
                    rank: {
                        margin: '0 3px',
                    },
                },
                iconSize: 0.6,
                fontSize: 9,
                height: 26,
            },
            footer: {
                margin: '0px 6px 0px 0px',
                height: 30,
            },
            _knownHeight: textKnownHeight,
        },
    },
}
